export const MerchantStatusType = {
  INVALID_MERCHANT_ID: 'INVALID_MERCHANT_ID',
  MERCHANT_ID_ALREADY_IN_USE: 'MERCHANT_ID_ALREADY_IN_USE',
};

export const MerchantStatusErrorMessage = t => {
  return {
    [MerchantStatusType.MERCHANT_ID_ALREADY_IN_USE]: {
      message: t('Merchant ID already linked to the account'),
    },

    [MerchantStatusType.INVALID_MERCHANT_ID]: {
      message: t('Invalid Merchant ID'),
    },
  };
};
